import { NetStateEnum, useStore } from '@tt4b/ttam-hooks';
import { NO_LIMIT } from '@tt4b/ttam-enums';
import { computed } from '@vue/composition-api';
import { i18n } from './../../../i18n';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useDataSource() {
  const { getStore } = useStore();
  const { data: ispList, run: loadData } = getStore(
    NetStateEnum.ispList,
    {
      queryParams: {
        countryIds: [],
      },
      scene: 1,
    },
    false,
    false
  );

  return {
    ispList,
    loadData,
  };
}

// eslint-disable-next-line  @typescript-eslint/explicit-function-return-type
export function useISPName(internetServiceProviders) {
  const { ispList } = useDataSource();
  const ispName = computed(() =>
    internetServiceProviders.map(item => {
      if (item === NO_LIMIT) {
        return i18n.t('adgroup_no_limit');
      }

      return ispList.value.find(e => e.value === item)?.label;
    })
  );

  return {
    ispName,
  };
}
